<section class="user-edit">
  <div class="card__header">
    <h2>Editar usuário</h2>
    <span
      class="close-btn material-icons"
      launchLabel="Fechar"
      launchSection="Clique"
      launchSiteSection="PortalDeLogons"
      plAnalyticsButton
      (click)="closeSideNav()"
      >
      close
    </span>
  </div>

  <form class="user-edit__form" [formGroup]="userEditForm">
    @if ((error$ | async) || (selectedLogon$ | async)?.error) {
      <pl-alert
        color="error"
        display="block"
        >
        <span header>{{ messageErrorObject.title }}</span>
        <span content>{{ messageErrorObject.description }}</span>
      </pl-alert>
    }

    @if (
      userEditForm.touched &&
      userEditForm.invalid &&
      userEditForm.controls['email'].hasError('required')
      ) {
      <pl-alert
        color="error"
        >
        <span header>Preencha todos os campos obrigatórios.</span>
      </pl-alert>
    }

    <div class="user-edit__form__field--user --block">
      <div class="user-edit__form__field--user__column">
        <div class="logon">
          <label for="logon">Logon</label>
          <span>{{ currentUser?.logon | uppercase }}</span>
        </div>
      </div>
    </div>

    <seds-form-field-dropdown
      label="Perfil *"
      [tabindex]="0"
      [(model)]="userProfile"
      [optionList]="profileList"
      [disabled]="true"
    ></seds-form-field-dropdown>

    <seds-form-field-text label="Nome">
      <input
        matInput
        id="name"
        name="name"
        title="insira seu nome"
        formControlName="name"
        required
        />
    </seds-form-field-text>

    <div
      style="position: relative"
      [ngClass]="{
        '--has-document': hasDocument,
        'user-edit__form__field--grid': !hasDocument
      }"
      >
      @if (!userEditForm.get('isForeign')?.value) {
        <seds-form-field-text
          label="CPF"
          >
          <input
            matInput
            required
            formControlName="document"
            mask="000.000.000-00"
            />
        </seds-form-field-text>
      }

      @if (userEditForm.get('isForeign')?.value) {
        <seds-form-field-text
          label="RNM"
          >
          <input matInput required formControlName="document" />
        </seds-form-field-text>
      }
      @if (!hasDocument) {
        <div class="has-document">
          <mat-checkbox
            formControlName="isForeign"
            >Estrangeiro</mat-checkbox
            >
          </div>
        }

        @if (!userEditForm.get('isForeign')?.value && hasDocument) {
          <i
            aria-label="Ícone de informações do CPF"
            class="material-icons user-edit__form__field--grid__ico"
            matTooltip="O CPF é um dado cadastral único. Após cadastrado, não poderá ser editado."
            matTooltipPosition="below"
            >
            info
          </i>
        }

        @if (userEditForm.get('isForeign')?.value && hasDocument) {
          <i
            aria-label="Ícone de informações do RNM"
            class="material-icons user-edit__form__field--grid__ico"
            matTooltip="O RNM é um dado cadastral único. Após cadastrado, não poderá ser editado."
            matTooltipPosition="below"
            >
            info
          </i>
        }
      </div>

      <seds-form-field-text
        [warningColor]="(userEditForm.get('email')?.value && userEditForm.get('email')?.dirty) ? true : false"
        label="E-mail"
        >
        <input matInput required formControlName="email" />
      </seds-form-field-text>

      <seds-form-field-text label="Número de celular">
        <input
          matInput
          formControlName="mobile"
          mask="(00) 00000 0000"
          />
      </seds-form-field-text>
    </form>
  </section>

  <pl-action-footer>
    <div
      class="action-footer__back"
      (click)="closeSideNav()"
      launchLabel="Voltar"
      launchSection="Clique"
      launchSiteSection="PortalDeLogons"
      plAnalyticsButton
      >
      <span class="material-icons">arrow_back_ios</span>
      <span>Voltar</span>
    </div>

    <seds-basic-button
      type="button"
      title="Salvar edição"
      [disabled]="userEditForm.invalid"
      (click)="save()"
      launchLabel="Salvar edição"
      launchSection="Clique"
      launchSiteSection="PortalDeLogons"
      plAnalyticsButton
      >
    </seds-basic-button>
  </pl-action-footer>
